import { find, isUndefined, last } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import icon_help from '../../../assets/images/icon_help.svg';
import {
  getIsMobileParam,
  isCustomerWebViewEnabled,
  isEmbeddedInIFrame,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import {
  BALANCES_AS_OF_MODAL,
  BUCKET_ROLL,
} from '../../../redux/modules/modals/modals.module';
import settings, {
  ADDRESS_INCOMPLETE,
  APP_FAILURE,
  BANK_STATUS,
  COLLEGE_BUY_REDIRECT,
  COLLEGE_SAVINGS,
  DOB_FAILURE,
  executingAppBuyMessages,
  executingBuyMessages,
  FOREIGN_ADDRESS,
  loadingBuySellAppMessages,
  NO_ELIGIBLE_FUNDS_IRAS_IRA_AUTOMAX,
  NOT_RETAIL_CLIENT,
  RECURRING_PURCHASE_APP_FAILURE,
  RECURRING_PURCHASE_FAILURE,
  TIMEOUT,
  NO_IRA_AUTO_MAX_FUNDS,
  IRA_AUTOMAX_REMAINING_ERROR,
  PURCHASE_FAILURE_IRA_AUTOMAX,
  MD529_DECOMMISSION,
  CUSTODIAN_ONLY,
} from '../../../settings/settings';
import { getLastFour } from '../../../utils/banking/bank-utils';
import { formatUnixDate } from '../../../utils/dates/date-utility';
import { appendBasePath } from '../../../utils/nav.utils';
import {
  isBuy,
  isAppBuy,
  isIRAAutoMax,
  isRecurringBuy,
  isRecurringBuyEdit,
  isRecurringContribute,
  isRecurringContributeEdit,
} from '../../../utils/transactions-util';
import ContributeDisclaimerNote from '../../CollegeContribute/ContributeDisclaimerNote/ContributeDisclaimerNote';
import RecurringBuySteps from '../../RecurringBuy/RecurringBuySteps/RecurringBuySteps';
import CollegeBrandingContainer from '../../Shared/CollegeBrandingContainer/CollegeBrandingContainer';
import ExcessiveTradingPolicyNote from '../../Shared/ExcessiveTradingPolicyNote/ExcessiveTradingPolicyNote';
import FullPageLoader from '../../Shared/FullPageLoader/FullPageLoader';
import If from '../../Shared/If/If';
import StepsPageBackground from '../../Shared/StepsPageBackground/StepsPageBackground';
import BuySteps from '../BuyFlow/BuySteps/BuySteps';
import { AppBuySteps } from '../../AppBuy/AppBuySteps';
import './BuyLanding.scss';
import { getHouseholdBalanceTierStatus } from '../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import IRAAutoMaxSteps from '../../IRAAutoMax/IRAAutoMaxSteps/IRAAutoMaxSteps';
import { scrollElementIntoFullView } from '../../../utils/dom-utils';
import { getUserNasuNewFunds } from '../../../redux/modules/funds/UserFunds/userFunds.selectors';
import { getHasNasuAddedFunds } from '../../../redux/modules/nasuAddedFunds/nasuAddedFunds.selectors';
import { getCollegeTypeCount } from '../../../redux/modules/productTypes/productType.selectors';
import { showStartDateToolTip } from '../../../utils/automatic/automatic-utils';
import { getErrorType as getBankLinkErrorType } from '../../../redux/modules/linkedBanks/linkBank.selectors';

export const testPushConfirm = (goIf) => {
  switch (true) {
    case isRecurringContributeEdit():
      return goIf('/automatic/contribute/edit/confirm');
    case isRecurringBuyEdit():
      return goIf('/automatic/buy/edit/confirm');
    case isRecurringContribute():
      return goIf('/automatic/contribute/confirm');
    case isRecurringBuy():
      return goIf('/automatic/buy/confirm');
    case isIRAAutoMax():
      return goIf('/automatic/ira-automax/confirm', checkIRAAutoMaxSuccess);
    case isAppBuy():
      return goIf('/advisory/add/confirm');
    default:
      return goIf('/buy/confirm');
  }
};
export const buildGoIf =
  (props, prevProps) =>
  (next, test = checkPurchaseSuccess) =>
    test(props, prevProps) && props.history.push(appendBasePath(next));

/**
 * checkPurchaseSuccess
 *
 * default test to see if a succesful purchase was just made
 * @param {*} props
 * @param {*} prevProps
 * @returns boolean
 */
export const checkPurchaseSuccess = (
  {
    executePurchase: {
      isLoaded,
      someFailed,
      allFailed,
      transactions,
      systematicDeferSuccess,
    },
  },
  { executePurchase: { isLoading: wasLoading, systematicDeferLoading } }
) =>
  Boolean(
    ((wasLoading && isLoaded) ||
      (systematicDeferLoading && systematicDeferSuccess)) &&
      transactions.length &&
      !(someFailed || allFailed)
  );

/**
 * checkIRAAutoMaxSuccess
 *
 * ira auto-max test to see if a successful automax plan was just created
 * @param {*} props
 * @param {*} prevProps
 * @returns boolean
 */
export const checkIRAAutoMaxSuccess = (
  { iraAutoMaxSubmission: { isLoaded, contributions, error } },
  { iraAutoMaxSubmission: { isLoading: wasLoading } }
) => {
  return Boolean(wasLoading && isLoaded && !error && contributions.length);
};

export class BuyLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundDisabled: false,
      submitButtonDisabled: false,
      redirectChecked: false,
    };
    this.disableBackground = this.disableBackground.bind(this);
    this.disableSubmitButton = this.disableSubmitButton.bind(this);
  }

  componentDidMount() {
    const { customerWebViewEnabled, isSalesforceRep, isIFrame } = this.props;
    if (customerWebViewEnabled) {
      this.setCustomerWebViewEnabled();
      this.disableSubmitButton();
    }
    if (isIFrame) {
      this.setIsIFrame();
      this.disableBackground();
    }
    if (isSalesforceRep) {
      this.setIsSalesforceRep();
      this.disableBackground();
    }
  }

  componentDidUpdate(prevProps) {
    const { executePurchase } = this.props;

    this.checkRedirect(prevProps);
    this.checkNeedPushConfirm(prevProps);
    this.checkSubmissionError(prevProps);
    this.checkAppFailed(prevProps);
    this.checkUpdateBankSelection(prevProps);
    this.checkBucketRoll(prevProps);

    if (executePurchase?.isLoading) {
      scrollElementIntoFullView('buy-landing');
    }
  }

  checkBucketRoll(prevProps) {
    const { bucketRoll: prevBucketRoll } = prevProps;
    const {
      actions: { openModal },
      bucketRoll,
      hasRetirementFunds,
    } = this.props;
    if (
      bucketRoll.nextYearContributionAmountAvailable &&
      bucketRoll !== prevBucketRoll &&
      hasRetirementFunds
    ) {
      openModal(BUCKET_ROLL);
    }
  }

  checkRedirect(prevProps) {
    const {
      location: { search, pathname },
      userProductTypes: {
        entity: {
          hasAK529,
          hasAPP,
          hasBrokerage,
          hasMD529,
          hasMutualFund,
          hasNAT529,
        },
      },
    } = prevProps;
    if (isRecurringBuy()) {
      if (
        pathname.includes('/edit') &&
        !search &&
        !pathname.includes('/confirm')
      ) {
        window.location.href = appendBasePath('/automatic');
      } else {
        if (
          (hasAK529 || hasMD529 || hasNAT529) &&
          !(hasMutualFund || hasAPP || hasBrokerage) &&
          pathname.includes('/buy')
        ) {
          if (pathname.includes('/edit')) {
            this.props.history.push(
              appendBasePath(`/automatic/contribute/edit${search}`)
            );
          } else {
            this.props.history.push(
              appendBasePath(`/automatic/contribute${search}`)
            );
          }
        }
        if (
          (hasMutualFund || hasAPP || hasBrokerage) &&
          pathname.includes('/contribute')
        ) {
          if (pathname.includes('/edit')) {
            this.props.history.push(
              appendBasePath(`/automatic/buy/edit${search}`)
            );
          } else {
            this.props.history.push(appendBasePath(`/automatic/buy${search}`));
          }
        }
      }
    }
  }

  checkNeedPushConfirm = (prevProps) =>
    testPushConfirm(buildGoIf(this.props, prevProps));

  checkSubmissionError(prevProps) {
    const {
      dispatchPageLoad,
      executePurchase: {
        hasFailed: purchaseFail,
        someFailed,
        allFailed,
        isLoaded,
      },
      iraAutoMaxSubmission,
    } = this.props;
    const {
      executePurchase: { isLoading: wasLoading },
      iraAutoMaxSubmission: { isLoading: wasLoadingIRAAutoMax },
    } = prevProps;

    if (
      (wasLoading && isLoaded && (purchaseFail || allFailed || someFailed)) ||
      (iraAutoMaxSubmission.hasFailed &&
        iraAutoMaxSubmission.isLoaded &&
        wasLoadingIRAAutoMax)
    ) {
      dispatchPageLoad('Submission Error Page');
    }
  }

  checkAppFailed(prevProps) {
    const {
      applicationData: { hasFailed: appFailed },
      dispatchPageLoad,
    } = this.props;
    const {
      applicationData: { isLoading: appWasLoading },
    } = prevProps;

    if (appWasLoading && appFailed) {
      dispatchPageLoad('App Error Page');
    }
  }

  setIsIFrame() {
    this.setState({ isIFrame: true });
  }

  setIsSalesforceRep() {
    this.setState({ isSalesforceRep: true });
  }

  setCustomerWebViewEnabled() {
    this.setState({ customerWebViewEnabled: true });
  }

  disableBackground() {
    this.setState({ backgroundDisabled: true });
  }

  disableSubmitButton() {
    this.setState({ submitButtonDisabled: true });
  }

  checkUpdateBankSelection(prevProps) {
    const {
      actions: { getBankMaps, selectBank },
      dispatch,
      existingBanks: { existingBanks, newBanks },
    } = this.props;
    const {
      existingBanks: { existingBanks: prevExistingBanks },
    } = prevProps;

    if (
      prevExistingBanks &&
      prevExistingBanks.length !== existingBanks.length
    ) {
      // TODO: Sam: This action type code does not belong here, we'll want to move it to middleware
      // or action observers, action actors, thunks, something like that when we get to that part
      // of refactoring. Leaving here for now. 4/18/2018
      dispatch(getBankMaps()).then(() => {
        const addedBank = newBanks.length >= 1 ? last(newBanks) : undefined;
        if (!isUndefined(addedBank)) {
          const newBank = find(existingBanks, (bank) => {
            const routingNumber = settings.isProd
              ? addedBank.routingNumber
              : '999999989';
            return (
              getLastFour(bank.accountNumber) ===
                getLastFour(addedBank.accountNumber) &&
              bank.routingNumber === routingNumber
            );
          });
          if (!isUndefined(newBank)) {
            if (!(isRecurringBuy() && !newBank.externallyVerifiedBank)) {
              newBank.bankStatus = BANK_STATUS.JUST_ADDED;
              selectBank(newBank);
              const {
                actions: { setEditMode },
                editModeBank: { editModeFlag },
              } = this.props;
              if (editModeFlag) {
                setEditMode(false);
              }
            }
          }
        }
      });
    }
  }

  render() {
    const {
      actions,
      allFunds,
      analyticsDataLayer,
      applicationData,
      automaticEditFund,
      availableFunds,
      currentYearInclusiveRemainingContributions,
      dateOfBirth,
      personalInfoFailed,
      dispatchPageLoad,
      editModeBank,
      eligibleBanks,
      executePurchase,
      iraAutoMaxSubmission,
      responseIRAAutoMaxCalculate,
      existingBanks: {
        existingBanks,
        fetchingAccounts: banksLoading,
        error,
        isLoaded,
      },
      flattenedPurchasingFunds,
      IRADataLookUp,
      IRALimit,
      hasAtleastOneFullyContributedIRA,
      isAddressAvailable,
      isNotForeignAddress,
      isCorporateAccountType,
      isFullyContributedIRA,
      isSingleBankWithDisabledStatus,
      nonRetirementMaxLimit,
      paperlessSetting,
      personalInformation: { data: personalData },
      priorYearInclusiveRemainingContributions,
      progress: { currentStep },
      purchasingFunds,
      quickBuy,
      getUserNewNasuFunds,
      nasuAddedNewFunds,
      selectedBank,
      selectedFunds,
      shoppingCart,
      shoppingCartTotal,
      userFunds,
      hasRasFundsOnly,
      hasAppFundsOnly,
      userFundsList,
      userProductTypes,
      vanityName,
      stopTransfer,
      windowCutoffDate,
      collegeTypeCount,
      doesUserHaveIRAs,
      hasIRAAutoMax,
      iraAutoMaxHiddenFundsSelectCall,
      bankLinkErrorType,
    } = this.props;
    const { openModal, setProgress } = actions;
    const { isIFrame } = this.state;
    const { isSalesforceRep } = this.state;
    const { customerWebViewEnabled } = this.state;
    const { backgroundDisabled } = this.state;
    const { submitButtonDisabled } = this.state;
    const funds = userFunds && userFunds.funds && userFunds.funds[0];
    const balanceAsOfDate = funds ? formatUnixDate(funds.balanceAsOfDate) : '';
    const displayTradeDate = funds
      ? formatUnixDate(funds.displayTradeDate)
      : '';
    const isLoaderVisible =
      iraAutoMaxSubmission.isLoading ||
      applicationData.isLoading ||
      executePurchase.isLoading ||
      executePurchase.systematicDeferLoading;
    const hasBuyPurchaseTradeDateFailed =
      executePurchase.eligibleTradeDatesFailed;
    const { retailEnabled } = personalData;
    const { hasAK529, hasMD529, hasNAT529, hasMutualFund } = userProductTypes
      ? userProductTypes.entity
        ? userProductTypes.entity
        : {}
      : {};
    const message = applicationData.isLoading
      ? loadingBuySellAppMessages
      : executePurchase.isLoading
      ? isAppBuy()
        ? executingAppBuyMessages
        : executingBuyMessages
      : isIRAAutoMax()
      ? iraAutoMaxSubmission.isLoading
      : '';

    const getError = () => {
      const result = _getError();
      return result;
    };
    const _getError = () => {
      if (!personalInfoFailed && !dateOfBirth && !isCorporateAccountType) {
        return {
          type: DOB_FAILURE,
          hasError: true,
        };
      }
      if ((isBuy() || isAppBuy()) && hasBuyPurchaseTradeDateFailed) {
        return {
          type: APP_FAILURE,
          hasError: true,
        };
      }
      if (!personalInfoFailed && !isNotForeignAddress) {
        return {
          type: FOREIGN_ADDRESS,
          hasError: true,
        };
      }
      if (
        applicationData.hasFailed ||
        responseIRAAutoMaxCalculate.hasFailed ||
        (IRALimit.hasFailed && !isCorporateAccountType)
      ) {
        return {
          type: APP_FAILURE,
          hasError: true,
        };
      }
      if (!retailEnabled && !isSalesforceRep) {
        return {
          type: NOT_RETAIL_CLIENT,
          hasError: true,
        };
      }
      if (executePurchase.timeout && !isRecurringBuy()) {
        return {
          type: TIMEOUT,
          hasError: true,
        };
      }
      // can check 0 index since APP only supports single automatic buys at a time
      if (
        (executePurchase.someFailed || executePurchase.allFailed) &&
        isRecurringBuy() &&
        selectedFunds[0].productType === 'ManagedAccount'
      ) {
        return {
          type: RECURRING_PURCHASE_APP_FAILURE,
          hasError: true,
        };
      }
      if (executePurchase.hasFailed || executePurchase.systematicDeferFailed) {
        return {
          type: TIMEOUT,
          hasError: true,
        };
      }
      if (iraAutoMaxSubmission.hasFailed) {
        return {
          type: PURCHASE_FAILURE_IRA_AUTOMAX,
          hasError: true,
        };
      }
      if (
        (executePurchase.someFailed || executePurchase.allFailed) &&
        isRecurringBuy()
      ) {
        return {
          type: RECURRING_PURCHASE_FAILURE,
          hasError: true,
        };
      }
      if (!isAddressAvailable) {
        return {
          type: ADDRESS_INCOMPLETE,
          hasError: true,
        };
      }
      if (!hasMutualFund && isBuy()) {
        return {
          type: COLLEGE_BUY_REDIRECT,
          hasError: true,
        };
      }

      if (
        (!doesUserHaveIRAs || !iraAutoMaxHiddenFundsSelectCall) &&
        isIRAAutoMax()
      ) {
        return {
          type: NO_ELIGIBLE_FUNDS_IRAS_IRA_AUTOMAX,
          hasError: true,
        };
      }

      if (
        hasIRAAutoMax <= IRA_AUTOMAX_REMAINING_ERROR &&
        isIRAAutoMax() &&
        isLoaded
      ) {
        return {
          type: NO_IRA_AUTO_MAX_FUNDS,
          hasError: true,
        };
      }

      if (
        (isRecurringContribute() || isRecurringBuy()) &&
        availableFunds.length === 0 &&
        collegeTypeCount === 0
      ) {
        return {
          type: MD529_DECOMMISSION,
          hasError: true,
        };
      }

      if (bankLinkErrorType === CUSTODIAN_ONLY) {
        return {
          type: CUSTODIAN_ONLY,
          hasError: true,
        };
      }

      return {
        type: '',
        hasError: false,
      };
    };

    const TransactionStepComponent = isIRAAutoMax()
      ? IRAAutoMaxSteps
      : isRecurringBuy()
      ? RecurringBuySteps
      : isAppBuy()
      ? AppBuySteps
      : BuySteps;

    const isCollegeEdit =
      isRecurringBuyEdit() &&
      availableFunds[0].agreementType === COLLEGE_SAVINGS;

    return (
      <div id="buy-page-container" className="buy-landing">
        <CollegeBrandingContainer>
          <FullPageLoader
            isVisible={isLoaderVisible}
            hasError={getError().hasError}
            errorType={getError().type}
            messages={message}
          />
          <If test={!backgroundDisabled}>
            <StepsPageBackground />
          </If>
          <div className="container">
            <TransactionStepComponent
              isIFrame={isIFrame}
              isSalesforceRep={isSalesforceRep}
              customerWebViewEnabled={customerWebViewEnabled}
              actions={actions}
              allFunds={allFunds}
              analyticsDataLayer={analyticsDataLayer}
              applicationData={applicationData}
              automaticEditFund={automaticEditFund}
              availableFunds={availableFunds}
              getUserNewNasuFunds={getUserNewNasuFunds}
              nasuAddedNewFunds={nasuAddedNewFunds}
              banksLoading={banksLoading}
              currentStep={currentStep}
              currentYearInclusiveRemainingContributions={
                currentYearInclusiveRemainingContributions
              }
              disableSubmitButton={this.disableSubmitButton}
              dispatchPageLoad={dispatchPageLoad}
              displayTradeDate={displayTradeDate}
              editModeBank={editModeBank}
              eligibleBanks={eligibleBanks}
              error={error}
              existingBanks={existingBanks}
              flattenedPurchasingFunds={flattenedPurchasingFunds}
              IRADataLookUp={IRADataLookUp}
              IRALimit={IRALimit}
              hasAtleastOneFullyContributedIRA={
                hasAtleastOneFullyContributedIRA
              }
              isCorporateAccountType={isCorporateAccountType}
              isFullyContributedIRA={isFullyContributedIRA}
              isLoaded={isLoaded}
              isSingleBankWithDisabledStatus={isSingleBankWithDisabledStatus}
              nonRetirementMaxLimit={nonRetirementMaxLimit}
              openModal={openModal}
              paperlessSetting={paperlessSetting}
              personalData={personalData}
              priorYearInclusiveRemainingContributions={
                priorYearInclusiveRemainingContributions
              }
              purchasingFunds={purchasingFunds}
              quickBuy={quickBuy}
              selectedBank={selectedBank}
              selectedFunds={selectedFunds}
              setProgress={setProgress}
              shoppingCart={shoppingCart}
              shoppingCartTotal={shoppingCartTotal}
              stopTransfer={stopTransfer}
              submitButtonDisabled={submitButtonDisabled}
              hasRasFundsOnly={hasRasFundsOnly}
              hasAppFundsOnly={hasAppFundsOnly}
              userFundsList={userFundsList}
              vanityName={vanityName}
              windowCutoffDate={windowCutoffDate}
            />

            <button
              className="buy-landing-balance-tooltip"
              onClick={() => openModal(BALANCES_AS_OF_MODAL)}
            >
              * Balances as of {balanceAsOfDate}
              <img
                id="balance-tooltip-icon"
                alt="help"
                className="buy-landing-balance-tooltip-icon"
                src={icon_help}
              />
            </button>

            <If test={isIRAAutoMax()}>
              <p>2820038</p>
            </If>

            <If test={isBuy() || isRecurringBuy()}>
              <hr />
              <ExcessiveTradingPolicyNote />
            </If>
            <If test={isRecurringBuy()}>
              <hr />
              <div className="buy-landing-startDate-disclaimer">
                Important information regarding the scheduled dates of your
                automatic{' '}
                {isRecurringContribute() ? 'contributions' : 'transactions'}.{' '}
                <a
                  className="buy-landing-link college-branded-link"
                  onClick={() => showStartDateToolTip(openModal)}
                >
                  View More
                </a>
              </div>
              <If
                test={
                  ((hasAK529 || hasMD529 || hasNAT529) &&
                    !isRecurringBuyEdit()) ||
                  isCollegeEdit
                }
              >
                <div className="buy-landing-contribute-disclaimer-note">
                  <ContributeDisclaimerNote />
                </div>
              </If>
            </If>
          </div>
        </CollegeBrandingContainer>
        <If test={isBuy()}>
          <p className="container">2819645</p>
        </If>
        <If
          test={
            !isBuy() &&
            (isRecurringBuy() || isRecurringBuyEdit()) &&
            !isAppBuy()
          }
        >
          <p className="container">2820024</p>
        </If>
        <If test={isAppBuy()}>
          <p className="container">2819645</p>
        </If>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    isIFrame: isEmbeddedInIFrame(state),
    isSalesforceRep: isSalesforceRep(state),
    collegeTypeCount: getCollegeTypeCount(state),
    householdBalanceTierStatus: getHouseholdBalanceTierStatus(state),
    isMobileParam: getIsMobileParam(state),
    getUserNewNasuFunds: getUserNasuNewFunds(state),
    nasuAddedNewFunds: getHasNasuAddedFunds(state),
    bankLinkErrorType: getBankLinkErrorType(state),
  };
};

export default compose(connect(mapStateToProps), withRouter)(BuyLanding);
